/* Crystal Quest: RO membrane performance curves v2 (snippets/cq-membrane-chart.liquid), datasheet style.
   flow = rated GPD x TCF(T) x (P - OSM) / (P_test - OSM)
     TCF, T in °C: exp(2640 x (1/298 - 1/(273 + T))) above 25°C, exp(3020 x (1/298 - 1/(273 + T))) at or below.
     P_test and OSM come from the section's data-test-psi and data-osm (product data; see the snippet header).
   data-mode picks the curve set: "pumped" (100 to 150 psi elements) or "residential" (line-pressure elements).
   Figure 1: x = feed temperature, one curve per feed pressure. Figure 2: x = feed pressure, one curve per temperature.
   Each figure: a range input (keyboard), click or drag on the plot to move the crosshair, click a curve or its legend
   button to highlight it (the others dim). Vanilla JS, inline SVG redrawn at the box's pixel width. */
(function () {
  'use strict';
  var NS = 'http://www.w3.org/2000/svg';
  var F_RATED = 77;

  function fToC(f) { return (f - 32) * 5 / 9; }
  function tcf(c) { var k = c > 25 ? 2640 : 3020; return Math.exp(k * (1 / 298 - 1 / (273 + c))); }
  function makeFlow(rated, pTest, osm) {
    return function (f, p) { return p <= osm ? 0 : rated * tcf(fToC(f)) * (p - osm) / (pTest - osm); };
  }
  function roundGpd(v) {
    if (v < 1000) return Math.round(v);
    if (v < 10000) return Math.round(v / 10) * 10;
    return Math.round(v / 100) * 100;
  }
  function fmt(n) { return Number(n).toLocaleString('en-US'); }
  function niceStep(max, n) {
    var raw = max / n, mag = Math.pow(10, Math.floor(Math.log(raw) / Math.LN10)), r = raw / mag;
    return (r <= 1 ? 1 : r <= 2 ? 2 : r <= 2.5 ? 2.5 : r <= 5 ? 5 : 10) * mag;
  }
  function el(name, attrs, parent) {
    var n = document.createElementNS(NS, name);
    for (var k in attrs) if (Object.prototype.hasOwnProperty.call(attrs, k)) n.setAttribute(k, attrs[k]);
    if (parent) parent.appendChild(n);
    return n;
  }
  function txt(parent, x, y, s, cls, anchor) {
    var t = el('text', { x: x, y: y, 'class': cls, 'text-anchor': anchor || 'middle' }, parent);
    t.textContent = s;
    return t;
  }
  var DASH = ['', '7 4', '2 3'];

  // Curve sets. Pumped: 100 to 150 psi elements, 40 to 95°F. Residential: household line pressure, the elements'
  // listed 20 to 60 psi and 40 to 90°F. The rated curve is the one at the product's own test pressure.
  var SETS = {
    pumped: { tMax: 95, tTicks: [40, 50, 60, 70, 80, 90], cTicks: [5, 10, 15, 20, 25, 30, 35], pressures: [150, 125, 100],
      pMax: 150, pClamp: 10, pTicks: [0, 25, 50, 75, 100, 125, 150], barTicks: [0, 2, 4, 6, 8, 10], bands: [{ from: 100, to: 150, label: 'Suggested range' }] },
    residential: { tMax: 90, tTicks: [40, 50, 60, 70, 80, 90], cTicks: [5, 10, 15, 20, 25, 30], pressures: [60, 50, 40],
      pMax: 60, pClamp: 5, pTicks: [0, 10, 20, 30, 40, 50, 60], barTicks: [0, 1, 2, 3, 4], bands: [{ from: 20, to: 60, label: 'Rated operating range' },
        { from: 50, to: 60, label: 'Recommended', strong: true }] }
  };

  function configs(rated, mode, pTest, osm) {
    var set = SETS[mode] || SETS.pumped;
    var flow = makeFlow(rated, pTest, osm);
    var pCurves = set.pressures.map(function (p) {
      return { label: p + ' psi', note: p === pTest ? 'rated' : '', v: function (x) { return flow(x, p); } };
    });
    var pRated = -1;
    set.pressures.forEach(function (p, i) { if (p === pTest) pRated = i; });
    return {
      temp: {
        min: 40, max: set.tMax,
        ticks: set.tTicks,
        top: { label: '°C', ticks: set.cTicks, toX: function (c) { return c * 9 / 5 + 32; } },
        xTitle: 'Feed temperature (°F)',
        at: function (x) { return 'At ' + x + '°F (' + Math.round(fToC(x)) + '°C)'; },
        curves: pCurves,
        rated: pRated >= 0 ? { x: F_RATED, curve: pRated } : null,
        bands: []
      },
      press: {
        min: 0, max: set.pMax, clampMin: set.pClamp,
        ticks: set.pTicks,
        top: { label: 'bar', ticks: set.barTicks, toX: function (b) { return b * 14.5038; } },
        xTitle: 'Feed pressure (psi)',
        at: function (x) { return 'At ' + x + ' psi (' + (x / 14.5038).toFixed(1) + ' bar)'; },
        curves: [
          { label: '77°F', note: 'rated', v: function (x) { return flow(F_RATED, x); } },
          { label: '60°F', v: function (x) { return flow(60, x); } },
          { label: '50°F', v: function (x) { return flow(50, x); } }
        ],
        rated: pTest <= set.pMax ? { x: pTest, curve: 0 } : null,
        bands: set.bands
      }
    };
  }

  function initFigure(fig, cfg) {
    var wrap = fig.querySelector('[data-cq-mc-js]');
    var box = fig.querySelector('[data-cq-mc-plot]');
    var range = fig.querySelector('[data-cq-mc-range]');
    var atOut = fig.querySelector('[data-cq-mc-at]');
    var legend = fig.querySelector('[data-cq-mc-legend]');
    if (!wrap || !box || !range || !atOut || !legend) return;
    wrap.hidden = false;

    var sel = cfg.rated ? cfg.rated.curve : 0, geo = null, lastW = 0;
    var paths = [], dots = [], cross = null, legendVals = [], legendBtns = [];

    // Legend buttons double as the value readout.
    cfg.curves.forEach(function (c, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'cq-mc2__key';
      b.setAttribute('aria-pressed', i === sel ? 'true' : 'false');
      var sw = el('svg', { 'class': 'cq-mc2__swatch', viewBox: '0 0 28 8', width: 28, height: 8, 'aria-hidden': 'true', focusable: 'false' });
      el('line', { x1: 1, x2: 27, y1: 4, y2: 4, 'stroke-dasharray': DASH[i] || '' }, sw);
      b.appendChild(sw);
      var name = document.createElement('span');
      name.className = 'cq-mc2__key-name';
      name.textContent = c.label + (c.note ? ' (' + c.note + ')' : '');
      b.appendChild(name);
      var val = document.createElement('span');
      val.className = 'cq-mc2__key-val';
      b.appendChild(val);
      b.addEventListener('click', function () { select(i); });
      legend.appendChild(b);
      legendBtns.push(b);
      legendVals.push(val);
    });

    function select(i) {
      sel = i;
      legendBtns.forEach(function (b, j) { b.setAttribute('aria-pressed', j === i ? 'true' : 'false'); });
      fig.setAttribute('data-sel', i);
      paths.forEach(function (p, j) {
        p.setAttribute('class', 'cq-mc2__curve' + (j === i ? ' is-sel' : ' is-dim'));
        if (j === i) p.parentNode.appendChild(p);
      });
      if (cross) cross.parentNode.appendChild(cross);
      Array.prototype.forEach.call(box.querySelectorAll('.cq-mc2__band-label'), function (bl) { bl.parentNode.appendChild(bl); });
      update();
    }

    function draw() {
      var W = Math.round(box.clientWidth);
      if (!W || W === lastW) return;
      lastW = W;
      var narrow = W < 560;
      var H = narrow ? 260 : 320;
      var m = { l: narrow ? 50 : 62, r: narrow ? 10 : 64, t: 34, b: 46 };
      var pw = W - m.l - m.r, ph = H - m.t - m.b;
      var ymaxRaw = 0;
      cfg.curves.forEach(function (c) { ymaxRaw = Math.max(ymaxRaw, c.v(cfg.max)); });
      var step = niceStep(ymaxRaw * 1.04, narrow ? 4 : 5);
      var ymax = Math.ceil(ymaxRaw * 1.04 / step) * step;
      function x(v) { return m.l + (v - cfg.min) / (cfg.max - cfg.min) * pw; }
      function y(v) { return m.t + ph - v / ymax * ph; }
      geo = { x: x, y: y, m: m, pw: pw, ph: ph, W: W, narrow: narrow };

      box.textContent = '';
      var svg = el('svg', { viewBox: '0 0 ' + W + ' ' + H, width: W, height: H, 'class': 'cq-mc2__svg', focusable: 'false' }, box);

      // Shaded ranges. A plain band labels its bottom left corner; a stronger (recommended) band inside it labels its
      // bottom right corner, and the plain label then moves to the top left (low pressure, curves are low there) so
      // the two never meet on a phone.
      var hasStrong = cfg.bands.some(function (b) { return b.strong; });
      cfg.bands.forEach(function (b) {
        el('rect', { x: x(b.from), y: m.t, width: x(b.to) - x(b.from), height: ph, 'class': 'cq-mc2__band' + (b.strong ? ' cq-mc2__band--strong' : '') }, svg);
        if (b.strong) txt(svg, x(b.to) - 6, m.t + ph - 8, b.label, 'cq-mc2__band-label cq-mc2__band-label--strong', 'end');
        else txt(svg, x(b.from) + 6, hasStrong ? m.t + 15 : m.t + ph - 8, b.label, 'cq-mc2__band-label', 'start');
      });
      // Horizontal grid and left axis ticks
      for (var v = 0; v <= ymax + 0.001; v += step) {
        if (v > 0 && v < ymax - 0.001) el('line', { x1: m.l, x2: m.l + pw, y1: y(v), y2: y(v), 'class': 'cq-mc2__grid' }, svg);
        el('line', { x1: m.l - 4, x2: m.l, y1: y(v), y2: y(v), 'class': 'cq-mc2__tickmark' }, svg);
        txt(svg, m.l - 7, y(v) + 4, fmt(v), 'cq-mc2__tick', 'end');
      }
      // Vertical grid and bottom axis ticks
      cfg.ticks.forEach(function (t) {
        if (t > cfg.min && t < cfg.max) el('line', { x1: x(t), x2: x(t), y1: m.t, y2: m.t + ph, 'class': 'cq-mc2__grid' }, svg);
        el('line', { x1: x(t), x2: x(t), y1: m.t + ph, y2: m.t + ph + 4, 'class': 'cq-mc2__tickmark' }, svg);
        txt(svg, x(t), m.t + ph + 17, String(t), 'cq-mc2__tick');
      });
      // Top axis in the second unit
      cfg.top.ticks.forEach(function (t) {
        var xv = cfg.top.toX(t);
        if (xv < cfg.min || xv > cfg.max) return;
        el('line', { x1: x(xv), x2: x(xv), y1: m.t - 4, y2: m.t, 'class': 'cq-mc2__tickmark' }, svg);
        txt(svg, x(xv), m.t - 8, String(t), 'cq-mc2__tick cq-mc2__tick--top');
      });
      txt(svg, m.l + pw, m.t - 22, cfg.top.label, 'cq-mc2__axis-title', 'end');
      // Frame
      el('rect', { x: m.l, y: m.t, width: pw, height: ph, 'class': 'cq-mc2__frame' }, svg);
      // Axis titles
      txt(svg, m.l + pw / 2, H - 6, cfg.xTitle, 'cq-mc2__axis-title');
      txt(svg, m.l - 7, m.t - 22, 'GPD', 'cq-mc2__axis-title', 'end');

      // Curves (selected one drawn last, on top)
      paths = [];
      cfg.curves.forEach(function (c, i) {
        var d = '', first = true;
        for (var xv = cfg.min; xv <= cfg.max + 0.001; xv += (cfg.max - cfg.min) / 160) {
          var yv = c.v(xv);
          if (yv <= 0 && cfg.bands.length) continue;
          d += (first ? 'M' : 'L') + x(xv).toFixed(1) + ' ' + y(yv).toFixed(1) + ' ';
          first = false;
        }
        var p = el('path', { d: d, 'class': 'cq-mc2__curve', 'stroke-dasharray': DASH[i] || '' }, svg);
        paths.push(p);
        if (!narrow) {
          var lt = txt(svg, m.l + pw + 6, y(c.v(cfg.max)) + 4, c.label, 'cq-mc2__curve-label', 'start');
          lt.setAttribute('data-i', i);
        }
      });
      // Spread right-hand curve labels that would overlap
      if (!narrow) {
        var labels = Array.prototype.slice.call(svg.querySelectorAll('.cq-mc2__curve-label'));
        labels.sort(function (a, b) { return a.getAttribute('y') - b.getAttribute('y'); });
        for (var li = 1; li < labels.length; li++) {
          var prev = parseFloat(labels[li - 1].getAttribute('y')), cur = parseFloat(labels[li].getAttribute('y'));
          if (cur - prev < 14) labels[li].setAttribute('y', prev + 14);
        }
      }
      // Rated point
      if (cfg.rated) {
        var rx = x(cfg.rated.x), ry = y(cfg.curves[cfg.rated.curve].v(cfg.rated.x));
        el('rect', { x: rx - 3.5, y: ry - 3.5, width: 7, height: 7, 'class': 'cq-mc2__rated' }, svg);
        // Above the point, or below it when the point sits near the top of the frame.
        txt(svg, rx - 8, ry - 8 < m.t + 12 ? ry + 16 : ry - 8, 'Rated', 'cq-mc2__rated-label', 'end');
      }

      // Crosshair group
      cross = el('g', { 'class': 'cq-mc2__cross' }, svg);
      el('line', { y1: m.t, y2: m.t + ph, 'class': 'cq-mc2__cross-line' }, cross);
      dots = cfg.curves.map(function () { return el('circle', { r: 3.5, 'class': 'cq-mc2__dot' }, cross); });

      // Pointer: click, tap or drag on the plot sets x; a click near a curve also highlights it.
      var hit = el('rect', { x: m.l, y: m.t, width: pw, height: ph, 'class': 'cq-mc2__hit' }, svg);
      var dragging = false;
      function toX(ev) {
        var r = svg.getBoundingClientRect();
        var px = (ev.clientX - r.left) * (W / r.width);
        var xv = cfg.min + (px - m.l) / pw * (cfg.max - cfg.min);
        var stepv = parseFloat(range.step) || 1;
        xv = Math.round(xv / stepv) * stepv;
        return Math.max(cfg.clampMin || cfg.min, Math.min(cfg.max, xv));
      }
      hit.addEventListener('pointerdown', function (ev) {
        var r = svg.getBoundingClientRect();
        var py = (ev.clientY - r.top) * (H / r.height);
        var xv = toX(ev), best = -1, bestD = 18;
        cfg.curves.forEach(function (c, i) { var dd = Math.abs(y(c.v(xv)) - py); if (dd < bestD) { bestD = dd; best = i; } });
        if (best >= 0 && best !== sel) select(best);
        setX(xv);
        dragging = true;
        if (hit.setPointerCapture) { try { hit.setPointerCapture(ev.pointerId); } catch (e) { /* ignore */ } }
      });
      hit.addEventListener('pointermove', function (ev) { if (dragging) setX(toX(ev)); });
      function end() { dragging = false; }
      hit.addEventListener('pointerup', end);
      hit.addEventListener('pointercancel', end);

      select(sel);
    }

    function setX(xv) {
      if (String(range.value) !== String(xv)) range.value = xv;
      update();
    }

    function update() {
      var xv = parseFloat(range.value);
      atOut.textContent = cfg.at(xv);
      var selVal = 0;
      cfg.curves.forEach(function (c, i) {
        var g = roundGpd(c.v(xv));
        legendVals[i].textContent = fmt(g) + ' GPD';
        if (i === sel) selVal = g;
      });
      range.setAttribute('aria-valuetext', cfg.at(xv) + ': ' + cfg.curves[sel].label + ' curve, about ' + fmt(selVal) + ' GPD');
      if (!geo || !cross) return;
      var cx = geo.x(xv);
      var line = cross.firstChild;
      line.setAttribute('x1', cx); line.setAttribute('x2', cx);
      cfg.curves.forEach(function (c, i) {
        dots[i].setAttribute('cx', cx);
        dots[i].setAttribute('cy', geo.y(c.v(xv)));
        dots[i].setAttribute('class', 'cq-mc2__dot' + (i === sel ? ' is-sel' : ''));
        if (i === sel) cross.appendChild(dots[i]);
      });
    }

    range.addEventListener('input', update);
    range.addEventListener('change', update);
    draw();
    update();
    if ('ResizeObserver' in window) new ResizeObserver(draw).observe(box);
    else window.addEventListener('resize', draw);
  }

  function init(root) {
    var rated = parseFloat(root.getAttribute('data-rated'));
    if (!(rated > 0)) return;
    var pTest = parseFloat(root.getAttribute('data-test-psi')) || 150;
    var osm = parseFloat(root.getAttribute('data-osm'));
    if (!(osm >= 0)) osm = 7.4;
    var cfgs = configs(rated, root.getAttribute('data-mode') || 'pumped', pTest, osm);
    var figs = root.querySelectorAll('[data-cq-mc-fig]');
    for (var i = 0; i < figs.length; i++) {
      var cfg = cfgs[figs[i].getAttribute('data-cq-mc-fig')];
      if (cfg) initFigure(figs[i], cfg);
    }
  }

  function boot() {
    var roots = document.querySelectorAll('[data-cq-mc]:not([data-cq-mc-ready])');
    for (var i = 0; i < roots.length; i++) {
      roots[i].setAttribute('data-cq-mc-ready', '');
      init(roots[i]);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
